import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
import {
    makeSelectTimesheetValue
    // @ts-ignore
} from 'services/timesheet/selectors';

interface ConnectedProps {
    personFirstName?: string;
}

type Props = ConnectedProps;

export class SelectedTimesheetPersonFirstNameValue extends React.PureComponent<
    Props
> {
    render(): string | null {
        const { personFirstName } = this.props;
        if (!personFirstName) {
            return null;
        }
        return personFirstName;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    personFirstName: makeSelectTimesheetValue('personFirstName')
});

export default connect(mapStateToProps)(SelectedTimesheetPersonFirstNameValue);
